module.exports = __webpack_public_path__ + "static/media/ellab.ba89c203.png";